module.exports = __webpack_public_path__ + "img/cznum.3edee388.gif";